const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');

class PinterestFeedChannel extends ChannelDefinition {
	id = 'pinterest-feed';
	title = 'Pinterest Feed';
	description = 'Inspire shoppers and drive sales by listing your products as shoppable Pins on Pinterest.';
	category = Categories.SOCIAL_COMMERCE;
	iconUrl = 'https://go.near.st/hubfs/channels/pinterest.svg';
	tag = 'Beta';
	comingSoon = true;
	feedExport = true;

	worksWith = ['storefront', 'product-reservations', 'local-checkout'];

	get pricing() {
		return 'Contact support to find out more';
	}

	longDescription = `
## Overview
Connect your product inventory to Pinterest and turn your products into shoppable Pins. Help customers discover and buy your in-store products while they browse for inspiration.

## How it works
NearSt generates a product feed from your live inventory that can be used to power your Pinterest product catalogue. Contact our support team to get set up.

## Requirements
- An active NearSt inventory connection
- A Pinterest Business account

Please check the catalogue setup instructions provided by Pinterest for up-to-date information on getting your products live using this feed.
	`;
}

module.exports = PinterestFeedChannel;
